<p-card styleClass="card-scroller">
    <ng-template pTemplate="header">
        <app-card-header [header]="header"></app-card-header>
    </ng-template>
    <ng-template pTemplate="content">
        <div class="scroll-container">
            <div class="scroller">
                <ng-content></ng-content>
            </div>
        </div>
    </ng-template>
</p-card>